module.exports = __webpack_public_path__ + "static/media/tag-running.b0a89473.svg";